
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.341 5a.75.75 0 00-.75.75v6.252a4.252 4.252 0 106.184 5.66h4.306a2.699 2.699 0 104.964-2.035v-.008h2.265l1.64 1.64a.75.75 0 001.061-1.06l-1.64-1.641v-2.096a.75.75 0 00-1.5 0v1.657h-1.826V11.33a1.68 1.68 0 00-1.68-1.68h-5.073L9.628 5.473A.75.75 0 008.93 5H3.342zm13.204 9.359v-3.028a.18.18 0 00-.18-.18H7.98a.75.75 0 01-.697-.473L5.624 6.5H4.09v4.754a4.252 4.252 0 015.286 4.91h3.704a2.699 2.699 0 013.464-1.805zM8.49 9.651L7.237 6.5h1.185l1.255 3.151H8.49zm-3.288 2.956a2.752 2.752 0 100 5.504 2.752 2.752 0 000-5.504zm9.273 4.306a1.198 1.198 0 112.395 0 1.198 1.198 0 01-2.395 0zm-9.273-2.31a.75.75 0 01.75.75v.01a.75.75 0 01-1.5 0v-.01a.75.75 0 01.75-.75z"}})])
          )
        }
      }
    